import { Link } from "react-router-dom";
import { ArrowRight, Compass, MessagesSquare, Sprout } from "lucide-react";
import PageHero from "@/components/layout/PageHero";

const IMG = "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200";

const VALUES = [
  { icon: Compass, title: "Direction, not destiny", text: "We help students see possibilities and next steps. We never claim to know the one right career for anyone, and interests are allowed to grow and change." },
  { icon: Sprout, title: "Strengths to build on", text: "Everything is described as everyday tendencies and strengths, in words a student will recognise and a parent can talk about calmly." },
  { icon: MessagesSquare, title: "Families decide together", text: "Every report includes a conversation guide for the family, and a one-on-one chat with a career counsellor is available on request." },
];

export default function About() {
  return (
    <div className="bg-ds-cream" data-testid="about-page">
      <PageHero eyebrow="About Disha" title="Guidance every student deserves, at the moment they need it." subtitle="Disha means direction. We built it so that every student from Class 7 to 12 can discover what they love and see where it can take them, with their family by their side." />
      <section className="ds-section bg-ds-cream">
        <div className="container-x grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 space-y-5 text-[17px] text-ds-ink leading-relaxed">
            <h2 className="ds-h2">Why we exist</h2>
            <p>Big choices arrive early: subjects and streams around Class 10, then courses and colleges around Class 12. Too often they are made on marks alone, or on what everyone else suggests.</p>
            <p>Disha offers a calmer starting point. A gentle five-stop journey, with questions chosen for the student's exact class, explores what they enjoy and how they like to work. It leads to a warm, personal report the whole family can read together, with career paths worth exploring and, from Class 9, courses, colleges and universities in India.</p>
            <p>And when you would like to talk it through, our career counsellors are happy to help.</p>
          </div>
          <div className="lg:col-span-6">
            <div className="rounded-t-[999px] rounded-b-[24px] overflow-hidden aspect-[4/5] max-w-md mx-auto border border-ds-plum/15">
              <img src={IMG} alt="A student and counsellor talking" className="h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </section>
      <section className="ds-section bg-ds-creamalt">
        <div className="container-x grid md:grid-cols-3 gap-10">
          {VALUES.map((v, i) => (
            <div key={v.title} data-testid={`about-value-${i}`}>
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ds-cream text-ds-plum"><v.icon className="h-6 w-6" /></span>
              <h3 className="mt-5 font-display text-2xl font-semibold text-ds-plumdeep">{v.title}</h3>
              <p className="mt-2 text-[16px] text-ds-inksoft leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>
        <div className="container-x mt-14 flex flex-col sm:flex-row gap-3">
          <Link to="/signup" className="ds-btn bg-ds-plum text-white hover:bg-[#3d0232]" data-testid="about-start-cta">Start the journey <ArrowRight className="h-4 w-4" /></Link>
          <Link to="/contact" className="ds-btn border-[1.5px] border-ds-plum text-ds-plum hover:bg-ds-plum/5" data-testid="about-contact-cta">Talk to us</Link>
        </div>
      </section>
    </div>
  );
}
